import { Card, Col, Form, Row, Button, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import MaskedInput from 'react-text-mask';
import axios from 'helpers/api';
import moment from "moment";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom'
import PatientModal from './PatientModal';
import * as mapYourMedsConstant from '../../common/mapYourMedsConstant'
import paths, { rootPaths } from '../../../routes/paths';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import DemoFileUpload from 'components/orderdetail/DemoFileUpload';
import AsyncSelect from 'react-select/async';
import { format } from 'd3';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import NurseCasemanagerPickers from '../staffing/NurseCasemanagerPickers';
import { isSharedLivingPatient } from 'helpers/isSharedLivingFacility';

/**
 * UI-067 / UD8: map a backend SL-105 staffing validation message to the
 * inline field error it belongs next to. Returns null when the message is
 * generic so we can fall back to a toast.
 */
const mapStaffingBackendError = (msg) => {
  const m = String(msg || '').toLowerCase();
  if (!m) return null;
  const next = {};
  if (m.includes('nurse')) next.nurse = msg;
  if (m.includes('case_manager') || m.includes('case manager')) next.case_manager = msg;
  return Object.keys(next).length > 0 ? next : null;
};

const AddEditPatient = (props) => {

    const [checked, setChecked] = useState(false);
    const [facilityoptions, setFacilityOptions] = useState([]);
    const [genderoptions, setGenderOptions] = useState([]);
    const [dobdate, setDobDate] = useState(null);
    const [admitdate, setAdmitDate] = useState(null);
    const [physicalexamdate, setPhysicalexamDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const formRef = useRef(null);
    const [errors, setErrors] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    //const location = useLocation();
    //const locationData = location.state;
    const [allergyvalue, setAllergyValue] = useState("");
    const [allergyOptions, setAllergyOptions] = React.useState([]);
    const [efsnovalue, setEfsNoValue] = useState("");
    const [efsnoOptions, setEfsnoOptions] = React.useState([]);
    const [insprtyvalue, setInsPrtyValue] = useState("");
    const [selectedAllergies, setSelectedAllergies] = useState([]);
    const [stateoptions] = useState([{ key: 'Select a state', value: '' },
    ...mapYourMedsConstant.STATE_VALUES]);
    const [insprtyOptions, setInsprtyOptions] = React.useState([]);
    const [ddsDropDown, setDdsDropDown] = useState([]);
    const [loading, setLoading] = useState(false);
    const [diseaseOptions, setDiseaseOptions] = useState([]);
    const [selectedDiseases, setSelectedDiseases] = useState([]);
    const [selectedHcp, setSelectedHcp] = useState(null);
    const [hcp, setHcp] = useState([]);
    // old initial form data
    // const initialFormData = {
    //     facilityname: '',
    //     firstname: '',
    //     lastname: '',
    //     dob: '',
    //     gender: '',
    //     entrydate: '',
    //     physicalexam: '',
    //     ssno: '',
    //     allergies: [],
    //     medsheetnote: '',
    //     efsinfo: '',
    //     insgrpno: '',
    //     insno: '',
    //     inspriority: '',
    //     is_program: true,
    //     is_medicate: false,
    //     efsno: '',
    // };

    const initialFormData = {
        firstName: "",
        middleName: "",
        lastName: "",
        nickname: "",

        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        primaryLanguage: "",
        race: "",
        insgrpno: "",
        dob: "",
        gender: "",
        startOfCare: "",
        physicalExamDate: "",
        ssn: "",
        ssno: '',
        is_createOrder: false,
        efsinfo: '',
        allergies: [],
        diagnosis: "",
        note: "",
        emergencyMedicalInfo: "",
        diagnoses: "",
        insno: "",
        groupNumber: "",
        idNumber: "",
        protectSelf: "",
        inspriority: "",
        guardianName: "",
        legalCompetencyStatus: "",
        is_program: true,
        is_medicate: false,
        formerAddress: "",
        formerCity: "",
        formerState: "",
        formerZip: "",

        familyAddress: "",
        familyCity: "",
        familyState: "",
        familyZip: "",
        dds: "",

        height: "",
        weight: "",
        build: "",
        hair: "",
        eyes: "",
        distinguishingMarks: "",

        behaviorCharacteristics: "",
        responseToSearch: "",
        patternOfMovement: "",
        placesFrequented: "",
        relevantCapabilities: "",
        disease: [],
        contactPerson: "",
        contactPhone: ""
    };

    const [allergy, setAllergy] = useState([])
    const [formData, setFormData] = useState(initialFormData);
    let roleId = Number(localStorage.getItem("roleId"))
    const isCaregiverRole = roleId === 7;

    // UI-068: SharedLiving staffing — current nurse / case-manager ids the
    // admin is editing. Seeded from props.data (set by the parent's
    // /patients/get-patient/:id fetch) and updated by NurseCasemanagerPickers.
    const [nurseUserId, setNurseUserId] = useState(props?.data?.nurse_user_id ?? null);
    const [caseManagerUserId, setCaseManagerUserId] = useState(props?.data?.case_manager_user_id ?? null);
    const [staffingErrors, setStaffingErrors] = useState({});

    const navigate = useNavigate();

    const handlePatientModal = (event) => {
        //console.log("PatientFormName " + event.target.id)
        localStorage.setItem("patientFormName", event.target.id);
        setShowModal(true);
    };

    async function setHcpDropDown() {
        let tokenStr = localStorage.getItem("accessToken");
        //TODO confirm with SHANKS whether listing is based on facility id or not

    }

    const loadDiseaseOptions = async (inputValue) => {
        if (!inputValue) return [];

        try {
            const tokenStr = localStorage.getItem("accessToken");
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/patients/search-icd/`,
                { search: inputValue },
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );

            const mapped = response.data.data.map((item) => ({
                label: `${item.code} - ${item.description}`,
                value: item.id
            }));

            setDiseaseOptions(mapped);
            return mapped;

        } catch (err) {
            console.error("Disease loading error:", err);
            return [];
        }
    };

    useEffect(() => {
        if (!props.patientid) return;
        if (!props.data?.icd_codes_text) return;

        const mapped = props.data.icd_codes_text.map(item => ({
            label: `${item.code} - ${item.description}`,
            value: item.id
        }));

        // Seed initial options so AsyncSelect can show preselected values
        setDiseaseOptions(prev => {
            // avoid duplicates
            const existingIds = prev.map(o => o.value);
            const filtered = mapped.filter(o => !existingIds.includes(o.value));
            return [...prev, ...filtered];
        });

        setSelectedDiseases(mapped);

        setFormData(prev => ({
            ...prev,
            disease: props.data.icd_codes_text.map(x => x.id) // IDs only
        }));
    }, []);

    useEffect(() => {
        async function populatePatientData() {

            let results = JSON.parse(localStorage.getItem("facilitiesData")) || [];

            let tokenStr = localStorage.getItem("accessToken");
            const getAllItems = {
                // "allergy": {}
                "dds": {},
                "patient_insurance": {
                    "group_id": props.data.group_id
                },
                "patient_insurance_priority": {
                    "group_id": props.data.group_id
                }
            }
            await axios.post(`${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`, getAllItems, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
                .then((res) => {
                    const results = res?.data?.output?.data?.patient_insurance.map((item) => ({
                        key: item.name,
                        value: item.id
                    }));
                    const resultsInsPrty = res?.data?.output?.data?.patient_insurance_priority.map((item) => ({
                        key: item.priority,
                        value: item.id
                    }));
                    const resultsDds = res?.data?.output?.data?.dds.map((item) => ({   
                        key: item.name,
                        value: item.id
                    }));
                    setDdsDropDown([
                        { key: 'Select DDS', value: '' },
                        ...resultsDds
                    ]);
                    setInsprtyOptions([
                        { key: 'Select Insurance Priority', value: '' },
                        ...resultsInsPrty
                    ]);
                    setEfsnoOptions([
                        { key: 'Select EFS Information', value: '' },
                        ...results
                    ]);

                    // const allergyDropdownOptions = res?.data?.output?.data?.allergy.map((item) => ({
                    //     value: item.id,
                    //     label: item.allergy,
                    // }));
                    // setAllergy(allergyDropdownOptions)
                })
            await axios.get(`${process.env.REACT_APP_SERVER_URL}/patients//list-patient-allergies/` + props.data.group_id, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
                .then((res) => {
                    const allergyDropdownOptions = res?.data?.data
                        ?.filter((item) => Number(item.is_active) === 1)
                        ?.map((item) => ({
                            value: item.id,
                            label: item.allergy,
                        }));
                    setAllergy(allergyDropdownOptions)

                    if (props.patientid && props.data?.allergies) {
                        const patientAllergyIds = props.data.allergies.split(",").map(id => id.trim()); // Convert "1,1198" to ["1", "1198"]

                        const preSelectedAllergies = allergyDropdownOptions.filter(opt => patientAllergyIds.includes(opt?.value?.toString()));

                        setSelectedAllergies(preSelectedAllergies);
                        setFormData((prev) => ({ ...prev, allergies: preSelectedAllergies.map(a => a.value) }));
                    }
                })

            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/doctors/list-doctors/" + props.data.group_id, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            let doctorResults = []

            //console.log("Doctor Data Status " + data.status);
            let objPatientData = data.data;

            objPatientData.forEach((value) => {
                if (Number(value.is_active) === 1) {
                    doctorResults.push({
                        label: value.lastname + ", " + value.firstname,
                        value: value.id,
                        address: value.address || "" + "," + value.address2 || "",
                        phone: value.phone,
                    });
                }
            });

            setHcp([
                ...doctorResults
            ])
            //console.log("Facility Points " + results);

            /***************DROPDOWN*****************/

            setFacilityOptions([
                { key: 'Select a facility', value: '' },
                ...results
            ]);

            setGenderOptions([
                {
                    key: 'Select a gender', value: ''
                },
                {
                    key: 'Male', value: 1
                },
                {
                    key: 'Female', value: 2
                },
                {
                    key: 'Others', value: 3,
                }
            ])

            // setInsprtyOptions([
            //     {
            //         key: 'Select Priority', value: ''
            //     },
            //     {
            //         key: 'High', value: 0
            //     },
            //     {
            //         key: 'Low', value: 1
            //     },
            //     {
            //         key: 'Medium', value: 2,
            //     }
            // ])

            /**********************EDIT PATIENT*****************************/

            if (props.patientid !== undefined) {
                let singlePatient = props.data;
                const p = props.data;

                //Old Data Mapping
                // setFormData({
                //     facilityname: singlePatient.facility_id,
                //     firstname: singlePatient.first_name,
                //     lastname: singlePatient.last_name,
                //     gender: singlePatient.gender,
                //     ssno: singlePatient.social_security_number,
                //     medsheetnote: singlePatient.medsheet_note,
                //     insgrpno: singlePatient.insurance_group_no,
                //     insno: singlePatient.insurance_no,
                //     is_program: singlePatient.is_active ? true : false,
                //     is_medicate: singlePatient.not_capable_selfmeditating ? false : true,
                //     inspriority: singlePatient.insurance_priority,
                //     allergies : singlePatient.allergies.split(','),
                //     efsno: singlePatient.insurance_efs_information,
                // });


                // setDobDate(singlePatient.dob != null ? moment(singlePatient.dob, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                // setAdmitDate(singlePatient.admit_date != null ? moment(singlePatient.admit_date, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                // setPhysicalexamDate(singlePatient.physical_exam_date != null ? moment(singlePatient.physical_exam_date, 'YYYY-MM-DD').format('MM/DD/YY') : null);

                setFormData({
                    firstName: p.first_name || "",
                    middleName: p.middle_name || "",
                    lastName: p.last_name || "",
                    nickname: p.nickname || "",
                    ssno: p.social_security_number || "",
                    address1: p.address || "",
                    insgrpno: p.insurance_group_no,
                    insno: p.insurance_no,
                    address2: p.address2 || "",
                    dds : p.dds_office_id || "",
                    city: p.city || "",
                    state: p.state || "",
                    is_program: p.is_active ? true : false,
                    is_medicate: p.not_capable_selfmeditating ? false : true,
                    zip: p.zip || "",
                    phone: p.phone || "",
                    primaryLanguage: p.primary_language || "",
                    race: p.race || "",
                    inspriority: p.insurance_priority,
                    insurance_efs_information: p.efsinfo,
                    dob: p.dob ? moment(p.dob, "YYYY-MM-DD").format("MM/DD/YYYY") : "",
                    gender: p.gender || "",
                    startOfCare: p.admit_date || "",
                    physicalExamDate: p.physical_exam_date || "",
                    ssn: p.ss_number || "",
                    is_createOrder: p.client_admit == 1,

                    // allergies: p.allergies ? p.allergies.split(",").map(a => a.trim()) : [],
                    allergies: p.allergies.split(','),
                    diagnosis: p.icd_codes || "",
                    note: p.medsheet_note || "",
                    emergencyMedicalInfo: p.emergency_medical_information || "",
                    diagnoses: p.diagnoses || "",

                    groupNumber: p.insurance_group_no || "",
                    idNumber: p.insurance_no || "",
                    protectSelf: p.protect_self || "",

                    guardianName: p.guardian_name || "",
                    legalCompetencyStatus: p.legal_competency_status || "",

                    formerAddress: p.former_address || "",
                    formerCity: p.former_city || "",
                    formerState: p.former_state || "",
                    formerZip: p.former_zip || "",

                    familyAddress: p.family_address || "",
                    familyCity: p.family_city || "",
                    familyState: p.family_state || "",
                    familyZip: p.family_zip || "",

                    height: p.height || "",
                    weight: p.weight || "",
                    build: p.build || "",
                    hair: p.hair || "",
                    eyes: p.eyes || "",
                    distinguishingMarks: p.distinguishing_marks || "",

                    behaviorCharacteristics: p.behavior_characteristics || "",
                    responseToSearch: p.response_to_search || "",
                    patternOfMovement: p.pattern_of_movement || "",
                    placesFrequented: p.places_frequented || "",
                    relevantCapabilities: p.relevant_capabilities || "",

                    contactPerson: p.contact_person || "",
                    contactPhone: p.contact_phone || ""
                });

                setDobDate(singlePatient.dob != null ? moment(singlePatient.dob, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                setAdmitDate(singlePatient.admit_date != null ? moment(singlePatient.admit_date, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                setPhysicalexamDate(singlePatient.physical_exam_date != null ? moment(singlePatient.physical_exam_date, 'YYYY-MM-DD').format('MM/DD/YY') : null);
                setSelectedHcp(singlePatient.physician_id ? doctorResults.filter(d => Number(d.value) === Number(singlePatient.physician_id))[0] : null);
                if (singlePatient.allergies != "" && singlePatient.allergies != null) {
                    if (singlePatient.allergies.includes(",")) {
                        let allergiesArray = singlePatient.allergies.split(',')
                        for (var i = 0; i < allergiesArray.length; i++) {
                            setAllergyOptions([...allergyOptions, { key: allergiesArray[i], value: allergiesArray[i] }])
                        }
                    }
                    else {
                        setAllergyOptions([...allergyOptions, { key: singlePatient.allergies, value: singlePatient.allergies }])
                    }
                }
                // if (singlePatient.insurance_efs_information != "" && singlePatient.insurance_efs_information != null) {
                //     if (singlePatient.insurance_efs_information.includes(",")) {
                //         let efsArray = singlePatient.insurance_efs_information.split(',')
                //         for (var i = 0; i < efsArray.length; i++) {
                //             setEfsnoOptions([...efsnoOptions, { key: efsArray[i], value: efsArray[i] }])
                //         }
                //     }
                //     else {
                //         setEfsnoOptions([...efsnoOptions, { key: singlePatient.insurance_efs_information, value: singlePatient.insurance_efs_information }])
                //     }
                // }
            };
        }
        // Trigger the fetch
        populatePatientData();
        // setHcpDropDown();
    }, []);

    const isValidZip = (zip) => {
        if (!zip) return true;              // optional field
        return /^\d{5}$/.test(zip);         // exactly 5 digits
    };


    const validateForm = () => {
        let validationErrors = {};

        if (!formData.allergies || formData.allergies.length === 0) {
            validationErrors.allergies = "Allergy is required";
        }

        if (!isValidZip(formData.zip)) {
            validationErrors.zip = "Zip Code format is not correct";
        }

        if (!isValidZip(formData.formerZip)) {
            validationErrors.formerZip = "Former Zip Code format is not correct";
        }

        if (!isValidZip(formData.familyZip)) {
            validationErrors.familyZip = "Family Zip Code format is not correct";
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handlePatientSubmit = async e => {

        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);

        if (true) {

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsPatientUrl = props.patientid !== undefined ? `${process.env.REACT_APP_SERVER_URL}` + "/patients/update-patient" : `${process.env.REACT_APP_SERVER_URL}` + "/patients/add-patient";

            let allergyManual = [];
            let efsManual = [];
            let insurancePriorityManual = [];

            allergyOptions.map((allergyoption) => {

                if (allergyoption.value != "") {
                    allergyManual.push(allergyoption.value);
                }
            });

            efsnoOptions.map((efsoption) => {
                if (efsoption.value != "") {
                    efsManual.push(efsoption.value);
                }
            });

            insprtyOptions.map((insprtyoption) => {

                if (insprtyoption.value != "") {
                    insurancePriorityManual.push(insprtyoption.value);
                }
            });

            let tempGender = formData.gender;
            // if (formData.gender == "Male") {
            //     tempGender = 1
            // }
            // else if (formData.gender == "Female") {
            //     tempGender = 2
            // }
            // else (formData.gender == "Others")
            // {
            //     tempGender = 3
            // }



            //Old Payload
            // let pelmedsPatientData = props.patientid !== undefined ?
            //     {
            //         id: props.patientid,
            //         group_id: localStorage.getItem("groupId"),
            //         facility_id: formData.facilityname,
            //         first_name: formData.firstname,
            //         last_name: formData.lastname,
            //         dob: moment(dobdate).format('MM/DD/YY'),//formData.dob,                    
            //         gender: tempGender,//temp fix
            //         admit_date: admitdate != null ? admitdate : '',//formData.entrydate,
            //         physical_exam_date: physicalexamdate != null ? physicalexamdate : '',//formData.physicalexam,
            //         ss_number: formData.ssno,
            //         allergies: formData.allergies,//localStorage.getItem("allergyValue"),//formData.allergy,
            //         medsheet_note: formData.medsheetnote,
            //         insurance_efs_information: formData.efsinfo,
            //         insurance_group_no: formData.insgrpno,
            //         insurance_no: formData.insno,
            //         insurance_priority: formData.inspriority,
            //         //is_program: formData.is_program,
            //         is_active: formData.is_program ? 1 : 0,
            //         not_capable_selfmeditating: formData.is_medicate ? 0 : 1,
            //         allergy_manual: allergyManual,
            //         efs_manual: efsManual,
            //         inspr_manual: insurancePriorityManual,
            //     }
            //     :
            //     {
            //         group_id: localStorage.getItem("groupId"),
            //         facility_id: formData.facilityname,
            //         first_name: formData.firstname,
            //         last_name: formData.lastname,
            //         dob: moment(dobdate).format('MM/DD/YY'),//formData.dob,
            //         gender: tempGender,//temp fix
            //         admit_date: admitdate != null ? admitdate : '',//formData.entrydate,
            //         physical_exam_date: physicalexamdate != null ? physicalexamdate : '',//formData.physicalexam,
            //         ss_number: formData.ssno,
            //         allergies: formData.allergies,//formData.allergy,
            //         medsheet_note: formData.medsheetnote,
            //         insurance_efs_information: formData.efsinfo,
            //         insurance_group_no: formData.insgrpno,
            //         insurance_no: formData.insno,
            //         insurance_priority: formData.inspriority,
            //         //is_program: formData.is_program,
            //         is_active: formData.is_program ? 1 : 0,
            //         not_capable_selfmeditating: formData.is_medicate ? 0 : 1,
            //         allergy_manual: allergyManual,
            //         efs_manual: efsManual,
            //         inspr_manual: insurancePriorityManual,
            //     };

            let pelmedsPatientData = {
                id: props.patientid || "",
                first_name: formData.firstName,
                middle_name: formData.middleName,
                last_name: formData.lastName,
                nickname: formData.nickname,
                social_security_number: formData.ssno,
                address: formData.address1,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zip: formData.zip,
                insurance_no: formData.insno,
                phone: formData.phone,
                is_active: formData.is_program ? 1 : 0,
                insurance_efs_information: formData.efsinfo,
                insurance_group_no: formData.insgrpno,
                insurance_priority: formData.inspriority,
                fax: "",
                primary_language: formData.primaryLanguage,
                ethnicity: "",
                race: formData.race,
                dob: formData.dob,
                gender: formData.gender,
                admit_date: admitdate,
                physical_exam_date: physicalexamdate,
                client_admit: formData.is_createOrder ? 1 : 0,

                allergies: formData.allergies ? formData.allergies.join(",") : '',
                // icd_codes: formData.disease ? formData.disease.join(",") : '',
                icd_codes: selectedDiseases.map(d => d.value).join(","),
                medsheet_note: formData.note,

                insurance_no: formData.idNumber,
                not_capable_selfmeditating: formData.is_medicate ? 0 : 1,
                medication_independent_status: "",

                physician_id: selectedHcp ? selectedHcp.value : "",
                // UI-068 / UD6: SharedLiving staffing assignment. Sending the
                // explicit string "null" is the "clear" signal backend SL-108
                // accepts (FormData coerces values to strings, so a JS null
                // would land as "null" anyway — be explicit). Backend silently
                // strips these for role 7 and ignores them on non-SL patients.
                nurse_user_id: (nurseUserId === null || nurseUserId === '') ? 'null' : nurseUserId,
                case_manager_user_id: (caseManagerUserId === null || caseManagerUserId === '') ? 'null' : caseManagerUserId,
                guardian_name: formData.guardianName,
                legal_competency_status: formData.legalCompetencyStatus,

                former_address: formData.formerAddress,
                former_city: formData.formerCity,
                former_state: formData.formerState,
                former_zip: formData.formerZip,

                family_address: formData.familyAddress,
                family_city: formData.familyCity,
                family_state: formData.familyState,
                family_zip: formData.familyZip,

                training_address: "",
                training_city: "",
                training_state: "",
                training_zip: "",
                training_phone: "",

                work_address: "",
                work_city: "",
                work_state: "",
                work_zip: "",

                height: formData.height,
                weight: formData.weight,
                build: formData.build,
                hair: formData.hair,
                eyes: formData.eyes,
                distinguishing_marks: formData.distinguishingMarks,

                emergency_medical_information: formData.emergencyMedicalInfo,
                diagnoses: formData.diagnoses,
                protect_self: formData.protectSelf,
                behavior_characteristics: formData.behaviorCharacteristics,
                response_to_search: formData.responseToSearch,
                pattern_of_movement: formData.patternOfMovement,
                places_frequented: formData.placesFrequented,
                relevant_capabilities: formData.relevantCapabilities,
                contact_person: formData.contactPerson,
                contact_phone: formData.contactPhone,
                dds_office_id: formData.dds
            };


            console.log("pelmedsPatientData ", (pelmedsPatientData));
            const formDataToSubmit = new FormData();
            Object.keys(pelmedsPatientData).forEach(key => {
                formDataToSubmit.append(key, pelmedsPatientData[key]);
            });
            if (uploadedFiles.length > 0) {
                formDataToSubmit.append("patient_pic", uploadedFiles[0], uploadedFiles[0].name);
            }


            try {
                setStaffingErrors({});
                const { data } = await axios.post(pelmedsPatientUrl, formDataToSubmit, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

                if (data.status && props.patientid === undefined) {
                    toast.success("Patient Details added successfully");
                    navigate(paths.viewPatient);
                } else if (data.status && props.patientid !== undefined) {
                    toast.success("Patient Details updated successfully");
                    navigate(paths.viewPatient);
                } else {
                    setLoading(false);
                    // UI-067 / UD8: route SL-105 nurse / case-manager validation
                    // messages to the inline picker errors so the admin sees
                    // them next to the offending field rather than as a toast.
                    const inline = mapStaffingBackendError(data.message);
                    if (inline) {
                        setStaffingErrors(inline);
                    } else {
                        toast.info(data.message || "Error occurred during adding/updating Patient Details");
                    }
                }
            } catch (error) {
                const msg = error?.response?.data?.message || error?.message || 'Failed to save patient data.';
                const inline = mapStaffingBackendError(msg);
                if (inline) {
                    setStaffingErrors(inline);
                } else {
                    toast.error(msg);
                }
            } finally {
                setLoading(false);  // End loading
            }

            //TODO REMOVE BELOW AS ITS NOT REQUIRED AND ITS REFERENCES
            //if (locationData == null) {
            //setFormData(initialFormData);
            //formRef.current.reset();
            //}
            //console.log("DataOutput " + JSON.stringify(data));
        }
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleNumberOnlyChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/\D/g, ''); // remove non-digits

        setFormData(prev => ({
            ...prev,
            [name]: numericValue
        }));
    };


    const handleHcpChange = (selectedHcp) => {
        setSelectedHcp(selectedHcp);
    }



    // Handler function for file upload

    const handleFileChange = (files) => {
        setUploadedFiles(files);

        console.log('Selected file:', files);
    };


    const handlePatientModalValue = async (modalvalue) => {
        let formName = localStorage.getItem("patientFormName");

        if (formName == "btnaddallergy") {
            let isDuplicate = handleDrpDuplicates(allergyOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate)
                setAllergyOptions([...allergyOptions, { key: modalvalue, value: modalvalue }])
        }
        else if (formName == "btnaddins") {
            let isDuplicate = handleDrpDuplicates(insprtyOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate)
                setInsprtyOptions([...insprtyOptions, { key: modalvalue, value: modalvalue }])
        }
        else if (formName == "btnaddefs") {
            let isDuplicate = handleDrpDuplicates(efsnoOptions, modalvalue);
            if (modalvalue != "" && !isDuplicate)
                setEfsnoOptions([...efsnoOptions, { key: modalvalue, value: modalvalue }])
        }
    };

    function handleDrpDuplicates(drpdwnOptions, modalvalue) {

        let isDuplicate = false;

        drpdwnOptions.map((singleoption) => {
            //console.log(singleoption.key + " && " + modalvalue);
            if (singleoption.key.toLowerCase() == modalvalue.toLowerCase()) {
                isDuplicate = true;
            }
        })

        return isDuplicate;
    }

    const handleCheckBoxChange = () => {
        setChecked(!checked);
    };

    const handleAllergyFieldChange = (e) => {
        //console.log("Target " + Array.from(e.target.selectedOptions, option => option.value));
        setAllergyValue(Array.from(e.target.selectedOptions, option => option.value));
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Add-Patient', href: paths.addPatient, isActive: true }
    ];

    return (
        <>
            {props.patientid ? [] : <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />}
            <Form ref={formRef} name="patientmainform">
                <Card className="mb-3">
                    <Card.Header as="h6" className="bg-body-tertiary">
                        {props.patientid !== undefined ? "Edit" : "Add"} Patient
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <fieldset disabled={isCaregiverRole} style={isCaregiverRole ? { pointerEvents: 'none' } : undefined}>
                            {/* ------------------------ SECTION: Personal Information ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Personal Information</h5>

                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                isInvalid={!!errors.firstName}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Middle Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="middleName"
                                                value={formData.middleName}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                isInvalid={!!errors.lastName}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Nickname</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="nickname"
                                                value={formData.nickname}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>SSNo</Form.Label>
                                            <MaskedInput
                                                mask={[/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}
                                                className="form-control"
                                                guide={false}
                                                placeholder="XXX-XX-XXXX"
                                                onChange={handleChange}
                                                size="sm"
                                                name="ssno"
                                                value={formData.ssno}
                                                disabled={isCaregiverRole}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Physical Exam</Form.Label>
                                            <DatePicker
                                                name="physicalexam"
                                                placeholderText="Select Physical Exam Date"
                                                className="form-control"
                                                selected={physicalexamdate ? moment(physicalexamdate).format("MM/DD/YY") : null}
                                                onChange={(physicalexamdate) =>

                                                    physicalexamdate != null ? setPhysicalexamDate(moment(physicalexamdate).format("MM/DD/YYYY")) : setPhysicalexamDate(null)
                                                }
                                                dateFormat="MM/dd/yy"
                                                disabled={isCaregiverRole}
                                            //maxDate={new Date()} 
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Entry Date</Form.Label>
                                            <DatePicker
                                                placeholderText="Select Admit Date"
                                                className="form-control"
                                                name="entrydate"

                                                selected={admitdate ? moment(admitdate).format("MM/DD/YY") : null}
                                                onChange={(admitdate) =>
                                                    admitdate != null ? setAdmitDate(moment(admitdate).format("MM/DD/YYYY")) : setAdmitDate(null)
                                                }
                                                dateFormat="MM/dd/yy"
                                                disabled={isCaregiverRole}
                                            // maxDate={new Date()} 
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>DOB <span className="text-danger">*</span></Form.Label>
                                            <DatePicker
                                                className="form-control"
                                                placeholderText="mm/dd/yy"
                                                selected={formData.dob ? moment(formData.dob).toDate() : null}
                                                onChange={date =>
                                                    handleChange({ target: { name: "dob", value: moment(date).format("MM/DD/YYYY") } })
                                                }
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={100}
                                                dateFormat="MM/dd/yy"
                                                isInvalid={!!errors.dob}
                                                disabled={isCaregiverRole}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Gender<span className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                name="gender"
                                                value={formData.gender}
                                                onChange={handleChange}
                                                isInvalid={!!errors.gender}
                                            >
                                                <option value="">Select Gender</option>
                                                <option value="1">Male</option>
                                                <option value="2">Female</option>
                                                <option value="3">Others</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Medical Information ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Medical Information</h5>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="required">Allergies</Form.Label>
                                            <Select
                                                isMulti
                                                isDisabled={isCaregiverRole}
                                                options={allergy}
                                                value={selectedAllergies}
                                                // value={allergyOptions.filter(opt => formData.allergies.includes(opt.value))}
                                                onChange={opts => {
                                                    setSelectedAllergies(opts);
                                                    handleChange({
                                                        target: { name: "allergies", value: opts.map(o => o.value) }
                                                    })
                                                }
                                                }
                                                classNamePrefix="react-select"
                                                className={errors.allergies ? "is-invalid" : ""}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Label>Diagnosis</Form.Label>
                                        <AsyncSelect
                                            isMulti
                                            isDisabled={isCaregiverRole}
                                            cacheOptions
                                            defaultOptions={diseaseOptions}
                                            loadOptions={loadDiseaseOptions}
                                            value={selectedDiseases}
                                            onChange={(options) => {
                                                setSelectedDiseases(options);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    disease: options.map(o => o.value)
                                                }));
                                            }}
                                            classNamePrefix="react-select"
                                            placeholder="Search disease..."
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>Note</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="note"
                                                value={formData.note}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col>
                                        <Form.Group>
                                            <Form.Check
                                                type='switch'
                                                name="is_program"
                                                id='is_program'
                                                checked={
                                                    formData.is_program
                                                }
                                                onChange={e =>
                                                    setFormData({
                                                        ...formData,
                                                        is_program: e.target.checked
                                                    })
                                                }
                                                label='Is Individual currently in this program ?(Check if YES)'
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Check
                                                type='switch'
                                                name="is_medicate"
                                                id='is_medicate'
                                                checked={
                                                    formData.is_medicate
                                                }
                                                onChange={e =>
                                                    setFormData({
                                                        ...formData,
                                                        is_medicate: e.target.checked
                                                    })
                                                }
                                                label='Assessed & Able to Self Medicate?(Check if YES)'
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Doctor Information</h5>

                                <Row className="mb-3">
                                    <Col>
                                        <Form.Group controlId="doctorName">
                                            <Form.Label>Physician`s Name</Form.Label>
                                            <ThemedSelect
                                                name="doctorName"
                                                isDisabled={isCaregiverRole}
                                                closeMenuOnSelect={true}
                                                placeholder="Select Physician"
                                                classNamePrefix="react-select"
                                                options={hcp}
                                                value={selectedHcp}
                                                getOptionLabel={option => option.label}
                                                getOptionValue={option => option.value}
                                                onChange={e => handleHcpChange(e)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Label>Physician`s ADDRESS</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name="doctorAddress"
                                            value={selectedHcp ? selectedHcp.address : ''}
                                            readOnly
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Label>Physician`s PHONE</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="doctorPhone"
                                            value={selectedHcp ? selectedHcp.phone : ''}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <div className="p-3 mb-4 border rounded bg-light-subtle">

                                <h5 className="mb-3 fw-bold">Insurance Information</h5>
                                <Row className="mb-2">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Insurance/EFS Information</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select
                                                    name="efsinfo"
                                                    onChange={handleChange}
                                                >
                                                    {efsnoOptions.map((efsoption) => {
                                                        var isEfsNoSelected = false;
                                                        if (props.patientid !== undefined) {
                                                            if (efsoption.value == formData.efsno) {
                                                                isEfsNoSelected = "selected";
                                                            }
                                                        }
                                                        return (
                                                            <option key={efsoption.value} value={efsoption.value} selected={isEfsNoSelected}>
                                                                {efsoption.key}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Button variant="outline-secondary" id="btnaddefs" onClick={handlePatientModal} disabled={isCaregiverRole}>
                                                    +
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Insurance Priority</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select
                                                    name="inspriority"
                                                    onChange={handleChange}
                                                >
                                                    {insprtyOptions.map((inspriorityoption) => {
                                                        var isInsrPrioritySelected = false;
                                                        if (props.patientid !== undefined) {
                                                            if (Number(inspriorityoption.value) == Number(formData.inspriority)) {
                                                                isInsrPrioritySelected = "selected";
                                                            }
                                                        }
                                                        return (
                                                            <option key={inspriorityoption.value} value={inspriorityoption.value} selected={isInsrPrioritySelected}>
                                                                {inspriorityoption.key}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Button variant="outline-secondary" id="btnaddins" onClick={handlePatientModal} disabled={isCaregiverRole}>
                                                    +
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Insurance Group Number</Form.Label>
                                            <Form.Control
                                                placeholder='Insurance Group Number'
                                                value={formData.insgrpno}
                                                name="insgrpno"
                                                onChange={handleNumberOnlyChange}
                                                type="text"
                                                size="sm"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Insurance Number</Form.Label>
                                            <Form.Control
                                                placeholder='Insurance Number'
                                                value={formData.insno}
                                                name="insno"
                                                onChange={handleNumberOnlyChange}
                                                type="text"
                                                size="sm"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Identity & Physical Characteristics ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Identity & Physical Characteristics</h5>

                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Race</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="race"
                                                value={formData.race}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Primary Language / Communication</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="primaryLanguage"
                                                value={formData.primaryLanguage}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Protect Self Without Assistance?</Form.Label>
                                            <Form.Select
                                                name="protectSelf"
                                                value={formData.protectSelf}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={3}>
                                        <Form.Group><Form.Label>Height</Form.Label>
                                            <Form.Control name="height" value={formData.height} onChange={handleNumberOnlyChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group><Form.Label>Weight</Form.Label>
                                            <Form.Control name="weight" value={formData.weight} onChange={handleNumberOnlyChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group><Form.Label>Build</Form.Label>
                                            <Form.Control name="build" value={formData.build} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group><Form.Label>Hair</Form.Label>
                                            <Form.Control name="hair" value={formData.hair} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Eyes</Form.Label>
                                            <Form.Control name="eyes" value={formData.eyes} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Distinguishing Marks</Form.Label>
                                            <Form.Control name="distinguishingMarks" value={formData.distinguishingMarks} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={12}>
                                        <DemoFileUpload
                                            onFilesChange={handleFileChange}
                                            textOfDoc={"Individual Image"}
                                            errorFlag={errors.document}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Address ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Address Information</h5>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Address 1</Form.Label>
                                            <Form.Control name="address1" value={formData.address1} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Address 2</Form.Label>
                                            <Form.Control name="address2" value={formData.address2} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Group><Form.Label>City</Form.Label>
                                            <Form.Control name="city" value={formData.city} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group><Form.Label>State</Form.Label>
                                            <Form.Select name="state" value={formData.state} onChange={handleChange}>
                                                {stateoptions.map(opt => (
                                                    <option value={opt.value} key={opt.value}>{opt.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group><Form.Label>Zip</Form.Label>
                                            <Form.Control
                                                name="zip"
                                                value={formData.zip}
                                                className={errors.zip ? "is-invalid" : ""}
                                                onChange={handleNumberOnlyChange}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.zip}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <h6 className="fw-semibold mt-3">Former Address</h6>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Former Address</Form.Label>
                                            <Form.Control name="formerAddress" value={formData.formerAddress} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Former City</Form.Label>
                                            <Form.Control name="formerCity" value={formData.formerCity} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Former State</Form.Label>
                                            <Form.Select name="formerState" value={formData.formerState} onChange={handleChange}>
                                                {stateoptions.map(opt => (
                                                    <option value={opt.value} key={opt.value}>{opt.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Former Zip</Form.Label>
                                            <Form.Control
                                                name="formerZip"
                                                value={formData.formerZip}
                                                onChange={handleNumberOnlyChange}
                                                isInvalid={!!errors.formerZip}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.formerZip}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group><Form.Label>DDS</Form.Label>
                                            <Form.Select name="dds" value={formData.dds} onChange={handleChange}>
                                                {ddsDropDown.map(opt => (
                                                    <option value={opt.value} key={opt.value}>{opt.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Guardian ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Guardian & Legal</h5>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Guardian Name</Form.Label>
                                            <Form.Control name="guardianName" value={formData.guardianName} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Legal Competency Status</Form.Label>
                                            <Form.Control name="legalCompetencyStatus" value={formData.legalCompetencyStatus} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Family Contacts ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Family & Emergency Contacts</h5>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Family Address</Form.Label>
                                            <Form.Control name="familyAddress" value={formData.familyAddress} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Family City</Form.Label>
                                            <Form.Control name="familyCity" value={formData.familyCity} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Family State</Form.Label>
                                            <Form.Select name="familyState" value={formData.familyState} onChange={handleChange}>
                                                {stateoptions.map(opt => (
                                                    <option value={opt.value} key={opt.value}>{opt.key}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Family Zip</Form.Label>
                                            <Form.Control
                                                name="familyZip"
                                                value={formData.familyZip}
                                                onChange={handleNumberOnlyChange}
                                                isInvalid={!!errors.familyZip}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.familyZip}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Contact Person</Form.Label>
                                            <Form.Control name="contactPerson" value={formData.contactPerson} onChange={handleChange} />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Contact Phone</Form.Label>
                                            <Form.Control name="contactPhone" value={formData.contactPhone} onChange={handleNumberOnlyChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Behavioral Profile ------------------------ */}
                            <div className="p-3 mb-4 border rounded bg-light-subtle">
                                <h5 className="mb-3 fw-bold">Behavioral Profile</h5>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Significant Behavior Characteristics</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="behaviorCharacteristics"
                                                value={formData.behaviorCharacteristics}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Likely Response to Search Efforts</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="responseToSearch"
                                                value={formData.responseToSearch}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group><Form.Label>Pattern of Movement If Lost</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="patternOfMovement"
                                                value={formData.patternOfMovement}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group><Form.Label>Places Frequented</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="placesFrequented"
                                                value={formData.placesFrequented}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Group><Form.Label>Relevant Capabilities / Limitations</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="relevantCapabilities"
                                                value={formData.relevantCapabilities}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* ------------------------ SECTION: Shared Living Staffing ------------------------ */}
                            {/*
                              UI-068: Nurse + case-manager pickers. Rendered
                              only for SL-eligible patients (UD2: SL-flagged
                              facility OR has home caregivers) and hidden
                              entirely for role-7 caregivers (UD5). Stale-
                              assignment banner (UI-070) lives inside the
                              component when the assigned user is is_active=0.
                            */}
                            {Number(localStorage.getItem("is_sharedliving_facility")) ? (
                                <NurseCasemanagerPickers
                                    groupId={props?.data?.group_id}
                                    nurse={props?.data?.nurse}
                                    caseManager={props?.data?.case_manager}
                                    nurseUserId={nurseUserId}
                                    caseManagerUserId={caseManagerUserId}
                                    onChangeNurse={setNurseUserId}
                                    onChangeCaseManager={setCaseManagerUserId}
                                    errors={staffingErrors}
                                />
                            ) : []}

                            {/* ------------------------ FORM END / ACTION BUTTONS ------------------------ */}
                            </fieldset>
                            {!isCaregiverRole && (
                                <Row>
                                    <Col className="d-flex justify-content-end">
                                        <Button variant="primary" onClick={handlePatientSubmit}>
                                            Update
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                        </Form>

                    </Card.Body>
                </Card>
                <PatientModal show={showModal} setShow={setShowModal} handlePatientModalValue={handlePatientModalValue} />
            </Form >
        </>
    );
};

AddEditPatient.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

AddEditPatient.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default AddEditPatient;

